export default __webpack_public_path__ + "static/media/EAST2460.34I-34264_-18488_0.029de753.jpg";